"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuBack;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

function MenuBack(_ref) {
  var goBack = _ref.goBack,
      item = _ref.item,
      backButtonProps = _ref.backButtonProps;

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      classes = _useContext.classes,
      renderBack = _useContext.renderBack;

  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], (0, _extends2["default"])({
    divider: true,
    button: true,
    onClick: goBack
  }, backButtonProps), /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    classes: {
      root: classes.header
    }
  }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], {
    className: classes.icon
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    classes: {
      root: classes.headerText
    },
    primary: /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.headerText
    }, typeof renderBack === 'function' ? renderBack(item) : item.text)
  }));
}

MenuBack.propTypes = {
  /**
   * Goes back to the previous item in the menu hierarchy
   */
  goBack: _propTypes["default"].func,

  /**
   * The menu item being rendered
   */
  item: _propTypes["default"].shape({
    text: _propTypes["default"].string
  }).isRequired
};
